import SelectedImagesCardDisplay from "./selectedImagesCardDisplay";
import BlueButton from "../../../common/BlueButton/BlueButton";
import PriceSelector from "../../../common/PriceSelector";
import InputBarSmall from "../../../common/InputBar/small";
import { useTranslation } from "react-i18next";

const SelectDisplayManager = ({
    item,
    replaceSelectedTemplate,
    updateSelectedTemplateComponent,
    removeSelectedTemplateQuestion,
    priceOptions,
}) => {
    const { t } = useTranslation("templatesPage");

    // Left content - Displays basic template info
    let contentLeft = (
        <>
            <p>{item.message || ""}</p>
            <div className="selectedTemplatesCardImageLoaderLicenseText">
                <p>{t("selectPageUploaded", { uploader: item.uploader })}</p>
                <p>Bits: {item.price || "0"}</p>
                {item.isPriceValid ? <p></p> : <p>{t("invalidPrice")}</p>}
            </div>
            <br />
            <BlueButton
                text={t("editButton")}
                onClick={() =>
                    replaceSelectedTemplate({ ...item, isEdit: !item.isEdit })
                }
                Name={item.id}
                isGray={false}
            />
        </>
    );

    // Right content - Editable fields for template details
    let contentRight = (
        <>
            <div className="selectedTemplatesCardImageLoaderEditContent">
                <p>{item.message || t("selectedPageEditOptions")}</p>
                <PriceSelector
                    defaultValue={item.price || "0"}
                    onChange={(e) => {
                        replaceSelectedTemplate({
                            ...item,
                            newPrice: e.target.value,
                            changed: true,
                        });
                    }}
                    priceList={priceOptions}
                    isValid={item.isPriceValid}
                />

                <InputBarSmall
                    placeholder={t("selectedPagePlaceholderName", {
                        name: item.name || item.title,
                    })}
                    onInput={(e) => {
                        replaceSelectedTemplate({
                            ...item,
                            newName: e.target.value,
                            changed: true,
                        });
                    }}
                />
            </div>

            <br />
            <br />

            <div className="selectedimagesCardContainerDisplayButtonsEdit">
                <BlueButton
                    text={t("updateButton")}
                    onClick={() => updateSelectedTemplateComponent(item)}
                    Name={item.id}
                    isGray={!item.changed}
                />
                <BlueButton
                    text={t("backButton")}
                    onClick={() =>
                        replaceSelectedTemplate({
                            ...item,
                            isEdit: !item.isEdit,
                        })
                    }
                    Name={item.id}
                    isGray={false}
                    isDark={true}
                />
            </div>
        </>
    );

    // Final content: SelectedImagesCardDisplay with dynamic content
    let content = (
        <SelectedImagesCardDisplay
            item={item}
            setLoading={item.isLoading}
            updateItem={updateSelectedTemplateComponent}
            removeItem={removeSelectedTemplateQuestion}
            replaceSelectedTemplate={replaceSelectedTemplate}
            isButtonGray={false}
            contentLeft={contentLeft}
            contentRight={contentRight}
        />
    );

    // Step to handle hidden templates - return empty if hidden
    if (item.isHidden) {
        content = <></>;
    }

    return content;
};

export default SelectDisplayManager;
